/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getPlayersBySeason = function (seasonId,events,players,category) 
{
    const endpoint = `/${seasonId}/${events}/${players}/${category}/playersBySeason`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getPlayersBySeason.js